import * as React from "react";
function SvgGunsight(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M29.965 17H22v-2h7.965C29.475 8.065 23.935 2.525 17 2.035V10h-2V2.035C8.065 2.525 2.525 8.065 2.035 15H10v2H2.035c.49 6.935 6.03 12.475 12.965 12.965V22h2v7.965c6.935-.49 12.475-6.03 12.965-12.965zM16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm1.5-17.5v3h-3v-3h3zm-2 1v1h1v-1h-1z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGunsight);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
